import { screens } from '../../../../config/breakpoints';

const phoneWidth = screens.phone_only.max.replace(/[^\d.-]/g, '');

const initFooter = () => {
  const footer = document.querySelector('.footer');
  if (footer) {
    const items = footer.querySelectorAll('.footer-nav-item');
    if (window.innerWidth < phoneWidth) {
      items.forEach(item => {
        const header = item.querySelector('.footer-nav-item-header');
        const body = item.querySelector('.footer-nav-item-body');
        body.style.maxHeight = 0;

        header.addEventListener('click', event => {
          if (item.classList.contains('open')) {
            item.classList.remove('open');
            body.style.maxHeight = 0;
          } else {
            item.classList.add('open');
            body.style.maxHeight = `${body.scrollHeight}px`;
          }
        });
      });
    } else {
      items.forEach(item => item.querySelector('.footer-nav-item-body').removeAttribute('style'));
    }
  }
};

const mql = window.matchMedia(`(max-width: ${phoneWidth}px)`);

mql.onchange = e => {
  initFooter();
};

document.addEventListener('DOMContentLoaded', initFooter);
